import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export const NavContainer = styled(motion.nav)`
  position: sticky; 
  top: 0;
  width: 100%; 
  z-index: 100;
  padding: 0 2rem; 
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  height: 70px; 
  
  background-color: ${props => props.$isArtMode ? 'transparent' : 'var(--background)'};
  
  display: flex;
  justify-content: space-between;
  align-items: center;

  /* The Ultra-Smooth Scroll Glow */
  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    z-index: -1;
    height: 140px; /* Taller height gives the gradient plenty of room to feather out */
    
    background-color: var(--background);
    
    /* The Magic: A multi-stop mask to create a non-linear, buttery fade */
    mask-image: linear-gradient(to bottom, black 25%, rgba(0,0,0,0.8) 50%, rgba(0,0,0,0.3) 75%, transparent 100%);
    -webkit-mask-image: linear-gradient(to bottom, black 25%, rgba(0,0,0,0.8) 50%, rgba(0,0,0,0.3) 75%, transparent 100%);
    
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    pointer-events: none;
    
    /* Fades in smoothly ONLY when scrolled down on the Art page */
    opacity: ${props => (props.$isArtMode && props.$isScrolled) ? 1 : 0};
    transition: opacity 0.6s cubic-bezier(0.22, 1, 0.36, 1);
  }

  @media (max-width: 768px) {
    padding: 0 1.5rem;
  }
`;
export const NavName = styled(Link)`
  font-family: var(--font-heading);
  font-size: 1.5rem;
  text-decoration: none;
  color: var(--primary-text);
  font-weight: 700;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  
  /* Desktop margin - The absolute arrow will float into this space */
  margin-right: 4rem; 

  @media (max-width: 768px) {
    margin-right: 2rem; /* Buffer for mobile */
  }
`;

export const NavArrow = styled.span`
  color: var(--primary-text);
  opacity: 0;
  width: 0;
  overflow: hidden;
  transition: all 0.35s ease;
  display: inline-block;
  white-space: nowrap;

  ${props => props.$direction === 'right' && css`
    position: absolute;
    left: 100%;       
    top: 50%;         
    transform: translateY(-50%); 
    padding-left: 6px; 
  `}

  ${props => props.$direction === 'left' && css`
    margin-right: 0; 
  `}
`;

export const SwitchButton = styled(Link)`
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  position: relative; 
  
  color: var(--secondary-text);
  font-family: monospace;
  font-size: 0.9rem;
  transition: color 0.3s ease;
  cursor: pointer;

  &:hover {
    color: var(--primary-text);
    
    ${NavArrow} {
      opacity: 1;
      width: 20px; 
      
      ${props => props.$direction === 'left' && css`
         margin-right: 0.5rem; 
      `}
    }
  }
`;